import type { FC, ReactNode } from 'react';
import { CloseButton } from '@mantine/core';
import { selectItem } from '@/features/analysisMapSlice';
import { useAppDispatch } from '@/app/hooks';
import TagManager from 'react-gtm-module';
import classes from './Item.module.css';

interface ItemProps {
  heading?: string;
  headingComponent?: ReactNode;
  subheading?: string;
  onClick?: () => void;
  isFloating?: boolean;
  children?: React.ReactNode;
  closeButton?: boolean;
  closeButtonGoogleEvent?: string;
  'data-testid'?: string;
}

export const Item: FC<ItemProps> = ({
  heading,
  subheading = '',
  headingComponent,
  isFloating = false,
  closeButton = false,
  closeButtonGoogleEvent,
  children,
  ...props
}) => {
  const dispatch = useAppDispatch();
  const headingOnly = subheading === '';
  const handleCloseButtonClick = () => {
    if (closeButtonGoogleEvent) {
      TagManager.dataLayer({
        dataLayer: {
          event: closeButtonGoogleEvent,
        },
      });
    }
    dispatch(selectItem({}));
  };
  const wrapperClass = `${classes.wrapper} ${
    isFloating ? classes.wrapperFloating : classes.wrapperHover
  }`;
  const headingClass = `${classes.heading} ${headingOnly ? classes.headingOnly : ''}`;
  return (
    <div
      className={wrapperClass}
      data-floating={isFloating}
      data-testid="grouped-item"
      {...props}
    >
      {subheading && (
        <div className={classes.infoBar}>
          <span className={classes.subHeading}>{subheading}</span>
          {closeButton && <CloseButton onClick={handleCloseButtonClick} />}
        </div>
      )}
      {(headingComponent && (
        <div className={headingClass}>{headingComponent}</div>
      )) ||
        (heading && <div className={headingClass}>{heading}</div>)}
      {children && <div className={classes.detailsWrapper}>{children}</div>}
    </div>
  );
};
